import styled from "styled-components";
import Example from "../assets/profile.png";

export const HomePage = styled.div`
  background-color: #ffffff;
  color: white;
  box-sizing: border-box;
  padding-bottom: 30px;
  width: 100%;
  margin-top: 50px;
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: static;
  top: 0;
  left: 0;
  right: 0;
  padding-inline: 40px;
  background-color: #ffffff;
  z-index: 9999999;
  transition: 1s ease-in-out;
  height: 80px;
  max-width: 1400px;
  margin-inline: auto;
`;
export const NavBar = styled.nav`
  display: flex;
  gap: 10px;
  @media (max-width: 950px) {
    display: none;
  }
  button {
    background-color: inherit;
    color: #000000;
    border: none;
    cursor: pointer;
    font-family: "Neue Machina";
    font-size: 18px;
  }
`;
export const HireMe = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: inherit;
  cursor: pointer;
  width: 130px;
  color: #000000;
  border: none;
  height: 44px;
  border-radius: 10px;
  font-family: "Neue Machina";
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  z-index: 0;
  transition: color 0.5s ease-in-out;

  @media (max-width: 950px) {
    display: none;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #ffea00, red);
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    border-radius: 10px;
    z-index: -1;
  }

  &:hover::before {
    opacity: 1;
  }

  &:hover {
    color: white;
  }
`;

export const Logo = styled.h1`
  font-family: "Neue Machina";
  font-weight: 700;
  color: #000000;
  cursor: pointer;
`;

export const ProfilePic = styled.img`
  border-radius: 50%;
  filter: drop-shadow(10px 10px 20px rgba(130, 107, 81, 0.505));
  background-color: rgba(176, 165, 126, 0.342);
  /* width: 500px; */
  border-radius: 10px;
  transform: scaleX(-1);
  margin-top: -110px;
  h1 {
    margin-top: 50px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const ProfileWrapper = styled.div`
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    color: black;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  @media (max-width: 1000px) {
    width: 100%;
    height: 650px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
export const ProfileWrapperAbout = styled.div`
  border-radius: 20px;
  height: 650px;
  padding: 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media (max-width: 1000px) {
    width: 100%;
    height: 400px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
export const SocialMediaButtons = styled.a`
  background-color: rgb(255, 255, 255);
  border-radius: 3px;
  display: flex;
  cursor: pointer;
  transition: background 0.5s ease-in-out;

  &:hover {
    background: linear-gradient(90deg, red, yellow);
    transition: background 0.5s ease;
  }

  svg {
    padding: 0 10px 10px 10px;
    stroke: #000000f2;
    &:hover {
      stroke: #ffffff;
      transition: 0.5s ease;
    }
    height: 100%;
    width: 100%;
  }
`;
export const SocialIconsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1400px;
  width: 100%;
  margin: 100px auto 0 auto;
  /* padding: 0 20px; */

  color: #000000;
  font-size: clamp(24px, 5vw, 60px); /* Responsive font sizing */
  text-align: center;
  font-weight: 600;
  font-family: "Neue Machina", sans-serif;
  z-index: 1;

  @media (max-width: 1000px) {
    margin-top: 60px;
    /* font-size: clamp(20px, 6vw, 40px); */
  }
`;

export const Greeting = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-bottom: 100px;
  h1 {
    font-family: "Neue Machina";
    font-weight: 400;
    font-size: 3vw;
    /* @media (max-width: 1400px) {
            font-size: 40px;
        } */
    @media (min-width: 1300px) {
      font-size: 40px;
    }
  }
  p {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: "Neue Machina";
  }
`;
export const Status = styled.span`
  background-color: lime;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
`;
export const LogoImg = styled.div`
  background-image: url(${Example});
  height: 30%;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
export const CVButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 10px;
  background: linear-gradient(90deg, red, yellow);
  border: none;
  /* width: 170px; */
  height: 40px;
  cursor: pointer;
  text-decoration: none;
  p {
    padding-inline: 10px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    background-color: #ffffff;
    width: 99.2%;
    height: 95%;
    border-radius: 10px;
    text-align: center;
    color: black;
    box-sizing: border-box;
    transition: 0.2s ease-in-out;
    font-weight: 600;
    font-family: "Neue Machina";
    gap: 10px;
    &:hover {
      background-color: transparent;
      color: white;
    }
    div {
      transition: 0.5s ease-in-out;
      transform: rotate(-90deg);
    }
  }
  &:hover p div {
    transform: rotate(0deg);
  }
`;
export const NameCon = styled.div`
  background: linear-gradient(90deg, red, pink, lime, yellow, blue, brown, red);
  border-radius: 13px;
  height: 30px;
  max-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  p {
    font: 500 14px/14px "Neue Machina";
    background: white;
    width: 99%;
    height: 90%;
    border-radius: 10px;
    text-align: center;
    color: black;
    padding: 7px 0;
    box-sizing: border-box;
    white-space: nowrap;
    padding-inline: 20px;
  }
`;
export const PersonalInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  grid-gap: 30px;
  z-index: 99999999;
  width: 100%;

  p {
    font-size: clamp(16px, 3.5vw, 20px);
  }
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
export const WindowBlack = styled.div`
  width: 100%;
  background-color: black;
`;
